import { render, staticRenderFns } from "./SearchSuggestionsDetails.vue?vue&type=template&id=78fa3926&"
import script from "./SearchSuggestionsDetails.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports